import { render, staticRenderFns } from "./CopilotToolCallResult.vue?vue&type=template&id=87f26dec"
import script from "./CopilotToolCallResult.vue?vue&type=script&lang=ts"
export * from "./CopilotToolCallResult.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports